import { render, staticRenderFns } from "./Linkedin.vue?vue&type=template&id=541a216d"
import script from "./Linkedin.vue?vue&type=script&lang=js"
export * from "./Linkedin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports